"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _first = _interopRequireDefault(require("lodash/first"));
var _i18n = require("../../Framework/i18n");
var _Transformers = require("../Modules/Designer/Utils/Transformers");
var _ServiceLocator = require("../ServiceLocator");
var _configuration = require("../configuration");
var _Selectors = require("../Reducers/ImageGallery/Selectors");
var _Actions = require("../Reducers/ImageGallery/Actions");
var _Selectors2 = require("../Reducers/DesignArea/Selectors");
var _Selectors3 = require("../Reducers/Fonts/Selectors");
var _Modifiers = require("../Reducers/ImageGallery/Modifiers");
var _Actions2 = require("../Reducers/DesignData/Actions");
var _DesignElementSelectors = require("../Reducers/DesignArea/DesignElementSelectors");
var _FontFaceRepository = require("../Modules/Designer/Utils/FontFaceRepository");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function getCanvasImageScalingWithImageData(canvasImage, imageData) {
  var currentPreview = canvasImage.imageData.preview;
  var nextPreview = imageData.preview;
  return canvasImage.scaling * (currentPreview.width / nextPreview.width);
}
function updateCanvasImageWithImageData(canvasImage, imageData) {
  return canvasImage.updateOptions((0, _Transformers.prepareImageObjectData)({
    imageData: imageData,
    src: "".concat((0, _configuration.getConf)('network.host')).concat(imageData.preview.url),
    scaling: getCanvasImageScalingWithImageData(canvasImage, imageData)
  }));
}
function updateLinkedCanvasImagesWithImageData(imageIdentifier, imageData) {
  _ServiceLocator.Services.store.dispatch((0, _Actions2.updateLinkedImagesWithImageData)(imageIdentifier, imageData));
  return _ServiceLocator.Services.designData.updateCanvasDataFromState();
}
var DesignerService = exports["default"] = /*#__PURE__*/function () {
  function DesignerService() {
    _classCallCheck(this, DesignerService);
    this.imageEditDialogContinueClickHandler = null;
    this.imageEditDialogCloseHandler = null;
  }
  _createClass(DesignerService, [{
    key: "openImageEditDialog",
    value: function () {
      var _openImageEditDialog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(identifier, canvas) {
        var _this = this;
        var options,
          _options$placeholderI,
          placeholderImageUpdate,
          _options$submitOnExit,
          submitOnExitClick,
          imageEditDialogIdentifier,
          userImages,
          originalImage,
          firstUserImage,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              if (!(!identifier && !this.checkDesignElementRestrictions('image'))) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _options$placeholderI = options.placeholderImageUpdate, placeholderImageUpdate = _options$placeholderI === void 0 ? false : _options$placeholderI, _options$submitOnExit = options.submitOnExitClick, submitOnExitClick = _options$submitOnExit === void 0 ? false : _options$submitOnExit;
              imageEditDialogIdentifier = 'imageEditDialog';
              userImages = (0, _get["default"])(_ServiceLocator.Services.store.state, 'imageGallery.userImages', []);
              originalImage = identifier && (0, _find["default"])(userImages, {
                identifier: identifier
              }) || null;
              if (originalImage) {
                _ServiceLocator.Services.store.dispatch((0, _Actions.setSelectedImageByIdentifier)(identifier));
                _ServiceLocator.Services.store.dispatch((0, _Actions.setModeToEdit)());
              } else {
                firstUserImage = (0, _first["default"])(userImages);
                firstUserImage && !firstUserImage.isPlaceHolderImage ? _ServiceLocator.Services.store.dispatch((0, _Actions.setSelectedImageByIdentifier)(firstUserImage.identifier)) : _ServiceLocator.Services.store.dispatch((0, _Actions.setSelectedImageByIdentifier)(null));
                _ServiceLocator.Services.store.dispatch((0, _Actions.setModeToAdd)());
              }
              this.imageEditDialogContinueClickHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var editMode, updatePosition, placeholderImageObject, image;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      editMode = (0, _Selectors.isEditMode)(_ServiceLocator.Services.store.state);
                      updatePosition = false;
                      if (!(editMode && !placeholderImageUpdate && !canvas.selectedObject)) {
                        _context.next = 4;
                        break;
                      }
                      throw new Error('imageEditDialogContinueClickHandler must be called in edit mode while either there is an active canvas object or placeholderImageUpdate is true');
                    case 4:
                      if ((0, _Selectors.isColorPreviewCompatible)(_ServiceLocator.Services.store.state)) {
                        _context.next = 6;
                        break;
                      }
                      return _context.abrupt("return");
                    case 6:
                      if (placeholderImageUpdate && (0, _Selectors2.hasPlaceHolderImagesForActiveDesignArea)(_ServiceLocator.Services.store.state)) {
                        placeholderImageObject = canvas.objects.find(function (obj) {
                          return obj.type === 'Image' && obj.imageData.isPlaceHolderImage;
                        });
                        updatePosition = {
                          x: placeholderImageObject.x,
                          y: placeholderImageObject.y
                        };
                        placeholderImageObject && placeholderImageObject.remove();
                      }
                      _ServiceLocator.Services.designData.commitChanges();
                      image = _ServiceLocator.Services.store.state.imageGallery.selectedImage;
                      _context.next = 11;
                      return _ServiceLocator.Services.designData.editFile(_objectSpread({}, image.operations), image, {
                        immediateCommit: true
                      });
                    case 11:
                      if (!(editMode && canvas.selectedObject)) {
                        _context.next = 21;
                        break;
                      }
                      if (!(originalImage && !(0, _Selectors.isHardModified)(image, originalImage))) {
                        _context.next = 17;
                        break;
                      }
                      _context.next = 15;
                      return updateLinkedCanvasImagesWithImageData(originalImage.identifier, image);
                    case 15:
                      _context.next = 19;
                      break;
                    case 17:
                      _context.next = 19;
                      return updateCanvasImageWithImageData(canvas.selectedObject, image);
                    case 19:
                      _context.next = 23;
                      break;
                    case 21:
                      _context.next = 23;
                      return _this.addImageFromUrl(canvas, (0, _Selectors.getPreviewUrlFromImageData)(image.preview), image, {
                        updatePosition: updatePosition
                      });
                    case 23:
                      _ServiceLocator.Services.ui.hide(imageEditDialogIdentifier);
                    case 24:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              this.imageEditDialogCloseHandler = submitOnExitClick ? this.imageEditDialogContinueClickHandler : function () {
                var selectedImage = _ServiceLocator.Services.store.state.imageGallery.selectedImage;
                if (selectedImage && originalImage && selectedImage.identifier === originalImage.identifier && !(0, _isEqual["default"])(selectedImage.operations, originalImage.operations)) {
                  _ServiceLocator.Services.designData.editFile(originalImage.operations, selectedImage, {
                    immediateCommit: true
                  });
                }
                _ServiceLocator.Services.ui.hide(imageEditDialogIdentifier);
              };
              _context2.next = 12;
              return Promise.all([!_ServiceLocator.Services.store.state.imageGallery.tags.length && this.loadTags(), !_ServiceLocator.Services.store.state.imageGallery.gallery.length && this.loadImages()]);
            case 12:
              _ServiceLocator.Services.ui.show(imageEditDialogIdentifier);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function openImageEditDialog(_x, _x2) {
        return _openImageEditDialog.apply(this, arguments);
      }
      return openImageEditDialog;
    }()
  }, {
    key: "loadTags",
    value: function () {
      var _loadTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _ServiceLocator.Services.store.dispatch((0, _Actions.fetchTags)());
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function loadTags() {
        return _loadTags.apply(this, arguments);
      }
      return loadTags;
    }()
  }, {
    key: "loadImages",
    value: function () {
      var _loadImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _ServiceLocator.Services.store.dispatch((0, _Actions.fetchGallery)());
            case 2:
              return _context4.abrupt("return", _context4.sent);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function loadImages() {
        return _loadImages.apply(this, arguments);
      }
      return loadImages;
    }()
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(file) {
        var response, url, term;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _ServiceLocator.Services.store.dispatch((0, _Actions.uploadImage)(file));
            case 2:
              response = _context5.sent;
              url = (0, _get["default"])(response, 'data.preview.url');
              term = (0, _get["default"])(response, 'data.message');
              if (term) {
                _ServiceLocator.Services.ui.alertMessage((0, _i18n.t)(term));
              }
              if (url) {
                _context5.next = 8;
                break;
              }
              throw new Error('Preview image url is not specified!');
            case 8:
              return _context5.abrupt("return", "".concat((0, _configuration.getConf)('network.host')).concat(url));
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function uploadFile(_x3) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }()
  }, {
    key: "addImageFromUrl",
    value: function () {
      var _addImageFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(canvas, url, imageData) {
        var options,
          _options$enlargeImage,
          enlargeImage,
          _options$updatePositi,
          updatePosition,
          _options$scaleToHalf,
          scaleToHalf,
          _options$autoSelect,
          autoSelect,
          locked,
          item,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
              canvas.clearSelection();
              _options$enlargeImage = options.enlargeImage, enlargeImage = _options$enlargeImage === void 0 ? false : _options$enlargeImage, _options$updatePositi = options.updatePosition, updatePosition = _options$updatePositi === void 0 ? false : _options$updatePositi, _options$scaleToHalf = options.scaleToHalf, scaleToHalf = _options$scaleToHalf === void 0 ? true : _options$scaleToHalf, _options$autoSelect = options.autoSelect, autoSelect = _options$autoSelect === void 0 ? true : _options$autoSelect;
              locked = (0, _Selectors2.getElementLockState)(_ServiceLocator.Services.store.state);
              _context6.next = 6;
              return canvas.addImage((0, _Transformers.prepareObjectData)({
                src: url,
                imageData: imageData,
                locked: locked,
                autoFit: locked
              }));
            case 6:
              item = _context6.sent;
              item.selected = !!autoSelect;
              item.fitCanvas(enlargeImage);
              if (scaleToHalf && item.scaling !== 1) {
                item.scaling *= 0.5;
              }
              if (updatePosition) {
                item.x = updatePosition.x;
                item.y = updatePosition.y;
              }
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function addImageFromUrl(_x4, _x5, _x6) {
        return _addImageFromUrl.apply(this, arguments);
      }
      return addImageFromUrl;
    }()
  }, {
    key: "addText",
    value: function () {
      var _addText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(canvas) {
        var textContent,
          autoColorCount,
          options,
          state,
          _options$fontSizeMin,
          fontSizeMin,
          _options$locked,
          locked,
          _options$fontItem,
          fontItem,
          _options$htmlContent,
          htmlContent,
          _options$fitCanvas,
          fitCanvas,
          text,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              textContent = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 'My Text';
              autoColorCount = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 1;
              options = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : {};
              if (this.checkDesignElementRestrictions('text')) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return");
            case 5:
              canvas.clearSelection();
              state = _ServiceLocator.Services.store.state;
              _options$fontSizeMin = options.fontSizeMin, fontSizeMin = _options$fontSizeMin === void 0 ? (0, _Selectors2.getFontSizeMin)(state) : _options$fontSizeMin, _options$locked = options.locked, locked = _options$locked === void 0 ? (0, _Selectors2.getElementLockState)(state) : _options$locked, _options$fontItem = options.fontItem, fontItem = _options$fontItem === void 0 ? (0, _find["default"])(state.fonts, {
                isDefault: true
              }) || state.fonts[0] : _options$fontItem, _options$htmlContent = options.htmlContent, htmlContent = _options$htmlContent === void 0 ? this.createColorizedTextContent(textContent, autoColorCount) : _options$htmlContent, _options$fitCanvas = options.fitCanvas, fitCanvas = _options$fitCanvas === void 0 ? true : _options$fitCanvas;
              if (fontItem) {
                _context7.next = 12;
                break;
              }
              _ServiceLocator.Services.ui.reportError((0, _i18n.t)('common.noFontsAvailable'));
              _context7.next = 17;
              break;
            case 12:
              _context7.next = 14;
              return _FontFaceRepository.FontFaceRepository.collectFromHTML(htmlContent);
            case 14:
              text = canvas.addText({
                content: htmlContent,
                fontSize: 16,
                fontSizeMin: fontSizeMin,
                fontItem: fontItem,
                locked: locked,
                autoFit: locked
              });
              text.selected = true;
              if (!locked && fitCanvas) {
                this.fitTextToCanvas(text);
              }
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function addText(_x7) {
        return _addText.apply(this, arguments);
      }
      return addText;
    }()
  }, {
    key: "fitTextToCanvas",
    value: function fitTextToCanvas(text) {
      var canvas = text.canvas;
      text.alignTo('center', 'center');
      text.fontSize = Math.max(text.fontSizeMin, Math.min(canvas.size.width, canvas.size.height) * 0.4);
      if (text.fontSize > text.fontSizeMin && text.getScaledSize().width > canvas.size.width) {
        text.fitCanvas();
      }
    }
  }, {
    key: "checkDesignElementRestrictions",
    value: function checkDesignElementRestrictions(targetElementType) {
      var state = _ServiceLocator.Services.store.state;
      var designData = (0, _Selectors2.getDesignDataForSelectedDesignArea)(state);
      var designProductionMethod = (0, _Selectors2.getSelectedDesignProductionMethod)(state);
      var result = (0, _DesignElementSelectors.checkDesignElementRestrictions)(designData, designProductionMethod, targetElementType);
      if (result) {
        _ServiceLocator.Services.ui.reportError((0, _i18n.t)("designElementRestrictions.addElementMessages.".concat(result.type).concat(result.max === 1 ? '_1' : ''), result));
        return false;
      }
      return true;
    }

    /**
     * @param {string} str
     * @param {number} [colorCount=1]
     * @param {object} [options={}]
     * @returns {string}
     */
  }, {
    key: "createColorizedTextContent",
    value: function createColorizedTextContent(str) {
      var colorCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$withPlacehol = options.withPlaceholder,
        withPlaceholder = _options$withPlacehol === void 0 ? true : _options$withPlacehol;
      var state = _ServiceLocator.Services.store.state;
      var fontParams = (0, _Selectors3.getDefaultFontParams)(state);
      var chunkLength = Math.ceil(str.length / colorCount);
      var content = str.match(new RegExp(".{1,".concat(chunkLength, "}"), 'g')).map(function (chunk, idx) {
        var color = (0, _Selectors2.getDefaultTextColor)(state, colorCount > 1 ? idx : null);
        var lastImageColor = (0, _Selectors2.getVectorizedImageColor)(state);
        var colorData = (0, _isEmpty["default"])(lastImageColor) ? (0, _Selectors2.createColorData)(color.identifier, color.paletteIdentifier, color.custom, color.value) : lastImageColor;
        return "<span style='color: ".concat(colorData.value, "; ").concat(fontParams, "' data-color='").concat(colorData.identifier, "'>").concat(chunk, "</span>");
      }).join('');
      return withPlaceholder ? (0, _Modifiers.createTextPlaceholder)(content) : content;
    }
  }]);
  return DesignerService;
}();
_defineProperty(DesignerService, "serviceName", 'DesignerService');